<template>
<div>
  <b-card>
    <b-row>
      <b-col>
        <div>
          <b-form-group label="Usuario">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" placeholder="Usuario" v-model="user" disabled></b-form-input>
          </b-input-group>
          </b-form-group>
        </div>

        <div>
          <b-form-group label="Saldo">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="number" placeholder="Saldo" v-model="saldo" disabled></b-form-input>
          </b-input-group>
          </b-form-group>
        </div>

        <div>
          <b-form-select v-model="active" :options="options"></b-form-select>
        </div>
        <br>
        <div>
        <b-button align='center' variant='outline-success' @click='save'>
            Guardar
        </b-button>
        </div>
      </b-col>
      <b-col align='center'>
         <qr-code :text='code' :size=250 error-level='L'></qr-code>
         <h3>Codigo: {{code}}  <b-btn variant='info' @click='update_code'> <i class="fa fa-refresh"></i></b-btn></h3>
      </b-col>
    </b-row>
  </b-card>
  <!-- <qrcode-reader @decode='onDecode'></qrcode-reader>
  <carnetsForm :typeEndPoint=''adminCarnetsShow'' :dataParams='this.$route.params' />-->
</div>
</template>
<script>
import carnetsForm from '@/components/modules/admin/carnets/form'

import inputText from '@/views/base/form/inputText'
import inputNumber from '@/views/base/form/inputNumber'
import inputSelect from '@/views/base/form/inputSelect'

export default {
  name: 'CarnetsFormEdit',
  components: {
    carnetsForm,
    inputText,
    inputNumber,
    inputSelect
  },
  data: function () {
    return {
      qr: '',
      options: [
        {
          'value': null,
          'text': 'Seleccione una Opcion',
          'selected': true
        },
        {
          'value': 1,
          'text': 'Activo'
        },
        {
          'value': 0,
          'text': 'Inactivo'
        }
      ],
      name: {
        'type': 'text-input',
        'name': 'name_user_primary',
        'label': 'Usuario',
        'placeholder': 'Seleccione usuario',
        'data': 'Juan'
      },
      user: '',
      saldo: '',
      recarga: 0,
      code: '',
      active: 1
    }
  },
  created () {
    this.search()
  },
  methods: {
    save () {
      let data = {
        'id': this.$route.params.id,
        'id_user_primary': this.$store.getters.adminCarnets.formData.id_user_primary,
        'saldo': (Number(this.saldo)+Number(this.recarga)),
        'active': this.active
      }

      let json = JSON.stringify(data)
      this.$store.dispatch('adminCarnetsUpdate', json).then(response => {
        console.log(response)
      })
    },
    update_code(){
      let json = JSON.stringify(this.$route.params)
      this.$store.dispatch('adminCarnetsUpdateCode',json).then(response =>{
        this.$root.showInfoDialog('Mensaje Informativo','Codigo actualizado','Aceptar')
        this.adminCarnetsShow(json)
      }).catch(error => {

      })
    },
    search () {
      let json = JSON.stringify(this.$route.params)
      this.adminCarnetsShow(json)
    },
    adminCarnetsShow(json){
      this.$store.dispatch('adminCarnetsShow', json).then(response => {
        console.log('response', this.$store.getters.adminCarnets)
        this.user = this.$store.getters.adminCarnets.formData.name_user_primary
        this.saldo = this.$store.getters.adminCarnets.formData.saldo
        this.active = this.$store.getters.adminCarnets.formData.active
        this.code = this.$store.getters.adminCarnets.formData.code
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/edit.vue